export default __webpack_public_path__ + "static/media/minusOnLight.02587302.svg";